import type {
  DataFilterDefinitionsDtoResponse,
  DataTableDataSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type CustomPageFilterQueryKey = readonly [
  pageId: string,
  columnKeys: string[],
  pageFilterSelections: DataTableDataSearchDto['selection'],
  customFilterSelections: DataTableDataSearchDto['selection'] | undefined,
  globalFilterSelections: DataTableDataSearchDto['selection'] | undefined,
  ...string[],
];

export const fetchCustomPageFilterData: QueryFunction<
  DataFilterDefinitionsDtoResponse,
  QueryKeyWithRole<CustomPageFilterQueryKey>
> = async ({ queryKey }) => {
  const [
    pageId,
    columnKeys,
    pageFilterSelections,
    customFilterSelections,
    globalFilterSelections,
  ] = unwrapQueryKeyWithRole(queryKey).params;

  try {
    const response =
      await portalGatewayClient.pageFilter.searchCustomPageFilterData(pageId, {
        filters: {
          ...globalFilterSelections,
          ...pageFilterSelections,
        },
        selection: customFilterSelections,
        columnKeys,
      });

    if (response.ok) {
      return response.data;
    }

    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error fetching custom page filter data'
      ),
      response
    );
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
